import React, { useId, useState } from 'react'
import { Input } from '~/shadcn/ui/input'
import { Field, FieldLabel, FieldContent } from '~/shadcn/ui/field'
import { InputGroupText } from '~/shadcn/ui/input-group'
import { cn } from '~/shadcn/lib/utils'

type Props = Omit<React.ComponentProps<typeof Input>, 'value' | 'onChange'> & {
  labelText: React.ReactNode
  value?: number
  onChangeValue(value: number): void
  className?: string
}

export function CurrencyInput({
  labelText,
  className,
  onChangeValue,
  value: numberValue,
  ...props
}: Props) {
  const [value, setValue] = useState(() => _toDisplayValue(numberValue))
  const currencyId = useId()

  return (
    <Field className={cn('w-full lg:w-60', className)}>
      <FieldLabel htmlFor={currencyId} className="text-sm font-medium">
        {labelText}
      </FieldLabel>
      <FieldContent>
        <Input
          id={currencyId}
          name={currencyId}
          aria-invalid={!!props['aria-invalid']}
          className="text-base!"
          type="text"
          inputMode="decimal"
          value={value || ''}
          onChange={(event) => {
            const typed = event.target.value
            const sanitized = typed.replace('.', ',').replace(/[^0-9,]/g, '')
            setValue(sanitized)
            onChangeValue(_formatValue(sanitized))
          }}
          onBlur={() => setValue(_toDisplayValue(numberValue))}
          rightElement={
            <InputGroupText className="text-base font-semibold text-primary">
              €
            </InputGroupText>
          }
          {...props}
        />
      </FieldContent>
    </Field>
  )
}

function _formatValue(value: string): number {
  const normalized = value.replace(',', '.').replace(/[^0-9.]/g, '')
  return Math.round(Number(normalized) * 100) / 100
}

function _toDisplayValue(num: number | undefined): string | undefined {
  return num != null
    ? num.toLocaleString('sk-SK', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : undefined
}
